export default {
    setLocalItem(key: string, value?: object) {
        if (value) {
            localStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.removeItem(key);
        }
    },

    getLocalItem(key: string) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : undefined;
    },

    removeLocalItem(key: string) {
        return localStorage.removeItem(key);
    },

    setLocalString(key: string, value?: string) {
        if (value) {
            localStorage.setItem(key, value);
        } else {
            localStorage.removeItem(key);
        }
    },

    getLocalString(key: string) {
        return localStorage.getItem(key) || '';
    },
};
